import type { SaleOrLease, SortOrder } from '../../types';

export const UPDATE_LISTING_GUID = 'UPDATE_LISTING_GUID';
export const updateListingGuid = (guid: string, buildoutListingId: number) => ({
  type: UPDATE_LISTING_GUID,
  payload: { guid, buildoutListingId },
});

export const SET_FLASH = 'SET_FLASH';
export const setFlash = (message?: string | null, variant?: string) => ({
  type: SET_FLASH,
  payload: { message, variant },
});

export const clearFlash = () => ({
  type: SET_FLASH,
  payload: { message: null, variant: null },
});

export const SET_SORT_ORDER = 'SET_SORT_ORDER';
export const setSortOrder = (changes: Partial<SortOrder>) => ({
  type: SET_SORT_ORDER,
  payload: { changes },
});

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const setSearchText = (searchText: string) => ({
  type: SET_SEARCH_TEXT,
  payload: { searchText },
});

export const SET_SALE_OR_LEASE = 'SET_SALE_OR_LEASE';
export const setSaleOrLease = (saleOrLease: SaleOrLease) => ({
  type: SET_SALE_OR_LEASE,
  payload: { saleOrLease }
});
